var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("h" + _vm.size),{tag:"component",staticClass:"c-title"},[(_vm.icon)?_c('k-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"size":_vm.iconSize}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/poi/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a311485","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/poi/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CTitle.vue
// module id = 2234
// module chunks = 1611